import { de, it } from "date-fns/locale";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { DEBUG } from "../";
import { english } from "./english";
import { german } from "./german";
import { italian } from "./italian";
import type { ClankTranslation } from "./shared";

export type SupportedLanguage = "en" | "it" | "de";

interface SupportedLanguageStruct {
  id: SupportedLanguage;
  display: string;
  content: ClankTranslation;
}

export const dateFnsLocale: Record<SupportedLanguage, any> = {
  it: { locale: it },
  de: { locale: de },
  en: {},
};

export const supportedLanguages: SupportedLanguageStruct[] = [
  { id: "en", display: "English", content: english },
  { id: "de", display: "Deutsch", content: german },
  { id: "it", display: "Italiano", content: italian },
];

export const isValidLanguage = (lang: string): lang is SupportedLanguage =>
  supportedLanguages.map(val => val.id).includes(lang as SupportedLanguage);

const initializeI18n = () => {
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      debug: DEBUG,
      fallbackLng: "en",
      load: "languageOnly",
      nonExplicitSupportedLngs: true,

      // Normally, we want `escapeValue: true` as it
      // ensures that i18next escapes any code in
      // translation messages, safeguarding against
      // XSS (cross-site scripting) attacks. However,
      // React does this escaping itself, so we turn
      // it off in i18next.
      interpolation: {
        escapeValue: false,
      },
      supportedLngs: supportedLanguages.map(val => val.id),
      resources: {
        en: {
          translation: english,
        },
        de: {
          translation: german,
        },
        it: {
          translation: italian,
        },
      },
    });
};

export default initializeI18n;
